import { render, staticRenderFns } from "./PlGuide.vue?vue&type=template&id=5bd0ce57&scoped=true&"
import script from "./PlGuide.vue?vue&type=script&lang=js&"
export * from "./PlGuide.vue?vue&type=script&lang=js&"
import style0 from "./PlGuide.vue?vue&type=style&index=0&id=5bd0ce57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0ce57",
  null
  
)

export default component.exports